module.exports = __webpack_public_path__ + "static/media/r51.7dde8ede.jpg";